<template>
  <h1
    class="choice-title"
    v-if="$store.getters?.getQuesInfo?.type === 1 && data?.isRequired"
    :class="{
      required: $store.getters?.getQuesInfo?.type === 1 && data?.isRequired,
    }"
  >
    <span v-if="$store.getters?.getQuesInfo?.showIndex">{{
      `${quesIndex + 1}、`
    }}</span
    >{{ data?.title }}
  </h1>
  <h1 class="choice-title" v-else :class="{ required: showAnswerRequired }">
    <span v-if="$store.getters?.getQuesInfo?.showIndex">{{
      `${quesIndex + 1}、`
    }}</span
    >{{ data?.title }}
  </h1>
  <div class="citys choice" @click="handleShowAreaClick">
    <div v-if="!isReview" class="choice-item">
      <p>{{ addr }}</p>
      <Icon name="arrow" size="0.4rem" color="#333" />
    </div>
    <div v-else class="choice-item">
      {{ value }}
    </div>
  </div>
  <Popup v-model:show="showArea" position="bottom">
    <Area
      :columns-num="data.questionType == 9 ? 2 : 3"
      :area-list="areaList"
      @confirm="handleConfirm"
      @cancel="handleCancel"
      placeholder="x"
    />
  </Popup>
</template>

<script>
import { ref, onMounted } from 'vue'
import { Icon, Popup, Area } from 'vant'
import '../choice/css/choice.scss'
import citys from '@/utils/area.js'
import { getAnswer } from '@/utils/tools'

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    value: {
      type: String,
      default: '',
    },
    quesIndex: {
      type: Number,
      default: 0,
    },
    // 临时处理答题个人题型必填显示
    showAnswerRequired: {
      type: Number,
      default: 0,
    },
    isReview: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Icon,
    Popup,
    Area,
  },
  emits: ['selectCity'],
  setup(props, ctx) {
    const showArea = ref(false)
    const areaList = citys
    const addr = ref(
      props.data.questionType === 9 ? '点击选择省市' : '点击选择省市区'
    )
    const answerArr = ref([])

    onMounted(() => {
      const localAnswer = getAnswer(props.data.questionKey)
      if (localAnswer) {
        addr.value = localAnswer?.[0]?.answerContent
      }
    })

    /**
     * 点击展示区域选择弹框
     */
    const handleShowAreaClick = () => {
      showArea.value = true
    }

    /**
     * 点击确定按钮
     */
    const handleConfirm = (list) => {
      let address = ''
      for (const i in list) {
        address += list[i].name
      }
      addr.value = address

      const answer = {
        questionKey: props.data.questionKey,
        optionKey: props.data.optionVoList[0].optionKey,
        answerContent: address,
        areaCode: list[list.length - 1].code,
      }
      answerArr.value[0] = answer
      const question = {
        questionKey: props.data.questionKey,
        answers: answerArr.value,
        questionType: props.data.questionType,
        value: list[list.length - 1].code,
      }

      ctx.emit('selectCity', question)
      showArea.value = false
    }

    /**
     * 点击取消按钮
     */
    const handleCancel = () => {
      showArea.value = false
    }

    return {
      showArea,
      areaList,
      addr,
      handleShowAreaClick,
      handleConfirm,
      handleCancel,
    }
  },
}
</script>
<style scoped></style>
